// extracted by mini-css-extract-plugin
module.exports = {"Advantage":"AdvantageSection_Advantage__1ccGU","Diamond":"AdvantageSection_Diamond__2GCtG","DiamondContainer":"AdvantageSection_DiamondContainer__2VD49"};